import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import NProgress from 'nprogress/nprogress';

import store from '@state/store';
import routes from './routes';

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: 'page',
});

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  store.dispatch('auth/validateToken');

  let matchesPermission = false;
  let token = store.getters['auth/token'];
  const refreshToken = store.getters['auth/refreshToken'];
  const authRequired = routeTo.matched.some(route => route.meta.authRequired);
  const routePermissions = typeof routeTo.meta.permission === 'string' ? [ routeTo.meta.permission ] : routeTo.meta.permission;

  if (!Object.keys(token).length && refreshToken) {
    await store.dispatch('auth/getNewToken');
    // @TODO have to handle when refresh token call failed 401 or something else
    token = store.getters['auth/token'];
  }

  if (!authRequired) return next();

  if (token && token.access_token) {
    let userPremissions = store.getters['auth/permissions'];

    for (let i = 0; i < routePermissions.length; i++) {
      if (userPremissions && userPremissions.includes(routePermissions[i])) {
        matchesPermission = true;
        break;
      }
    }
  }

  if (matchesPermission) {
    next();
  } else {
    next({
      name: 'login',
      query: {
        redirectFrom: routeTo.fullPath,
      },
    });
  }
});

router.beforeResolve((routeTo, routeFrom, next) => {
  if (routeFrom.name) {
    NProgress.start();
  }
  next();
});

router.afterEach((routeTo, routeFrom) => {
  NProgress.done();
});

export default router;
